/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { AnvilorFormsAppStore } from "../anvilor-forms-app-store.service";
import { AnvilorFormsAppStoreContext } from "../anvilor-forms-app-store.service";
import { ThemeService } from "@anvilor/ngx-theming";
import { StandardThemeConfig } from "@anvilor/ngx-theming";
import { Observable } from "rxjs";
import { tap } from "rxjs";
import { filterUndefined } from "@anvilor/ngx-core-utils";
import { rstrip } from "@anvilor/ngx-core-utils";
import { map } from "rxjs/operators";
import { AnvilorFormDisplayConfig } from "../../models/anvilor-form-document";

const DENSITY_COMPACT_CLASS = "density-compact";

export class AnvilorFormsAppDensity {
  private store: AnvilorFormsAppStore;
  readonly compactMode$: Observable<boolean>;

  constructor(ctx: AnvilorFormsAppStoreContext) {
    this.store = ctx.store;
    this.compactMode$ = ctx.store.selectFromDisplayConfig(
      (c) => c.compact_mode ?? false
    );
  }

  bindDensity() {
    this.store.subscribeTo(
      this.compactMode$.pipe(tap((mode) => this.setDensityClassFromCompactMode(mode)))
    );
  }

  private setDensityClassFromCompactMode(compactMode: boolean) {
    if (compactMode) {
      document.body.classList.add(DENSITY_COMPACT_CLASS);
    } else {
      document.body.classList.remove(DENSITY_COMPACT_CLASS);
    }
  }
}
